import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { useRecoilState } from "recoil";
import { useHistory } from "react-router-dom";

import { Button } from "../../../../../Components/Button";
import { ReactComponent as RemixBadge } from "../../../../../../assets/images/badges/remix-icon.svg";
import { StudioSession } from "../../../../../State/studioSession";
import { Moment } from "MVVM/Components/QuickEdit/Moment";
import { analytics } from "MVVM/Analytics";

export const RemixHeader = ({
  remixData,
  remixedCards,
  postRemix,
  hidden,
}: any) => {
  const [studioSession] = useRecoilState(StudioSession);
  const history = useHistory();
  if (!remixData.moment) {
    return null;
  }
  if (hidden) return <></>;
  return (
    <StyledPage justifyContent="space-between">
      <StyledRemix
        flexDirection={["column", "column", "column", "column"]}
        justifyContent="space-between"
      >
        <Flex
          flexDirection={["column"]}
          justifyContent="center"
          height={"100%"}
        >
          <Moment moment={remixData.moment} hideTimelineLabel />

          <Flex style={{ gap: 12 }} justifyContent={"center"} mt={4}>
            <Button
              classification="roundedFilledAlt"
              size="small"
              maxHeight={32}
              onClick={() => {
                analytics.track("Quick Edit Custom Flow - Back", {});
                history.goBack();
              }}
              flex={true}
            >
              Back
            </Button>
            {remixData.moment.clip ? (
              <StyledRemixButton
                disabled={!remixedCards.length && !studioSession.useSignature}
                classification="remixFeed"
                alignSelf={"center"}
                onClick={postRemix}
                maxHeight={32}
              >
                <StyledIcon />
                Remix Clip
              </StyledRemixButton>
            ) : (
              <Button
                flex={true}
                disabled={!remixedCards.length && !studioSession.useSignature}
                classification="roundedFilled"
                alignSelf={"center"}
                size="tiny"
                onClick={postRemix}
              >
                Create Clip
              </Button>
            )}
          </Flex>
        </Flex>
      </StyledRemix>
    </StyledPage>
  );
};

export const StyledRemixButton = styled(Button)`
  align-items: center;
  flex-basis: content;
  font-size: 16px;
  line-height: 1.9;
  padding-left: 35px;
  padding-right: 35px;
  ${({ disabled }) =>
    disabled &&
    `
    opacity: .75;
    border-color: transparent;
  `}
`;

export const StyledIcon = styled(RemixBadge)`
  flex-shrink: 0;
  height: 18px;
  margin-right: 8px;
  width: 18px;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    margin-right: 5px;
    height: 14px;
    width: 14px;
  }
`;

const StyledRemix = styled(Flex)`
  background-color: ${(props: any) => props.theme.colors.midnight};
  border-color: ${(props: any) => props.theme.colors.alert};
  border-radius: 0;
  border-top: 2px solid;
  bottom: 0;
  color: ${(props: any) => props.theme.colors.ice};
  height: 150px;
  margin: auto;
  padding: 15px;
  position: fixed;
  right: 0;
  width: 100%;
  z-index: 8;

  @supports (backdrop-filter: blur(70px)) {
    & {
      background-color: #130c18b3;
      backdrop-filter: blur(70px);
    }
  }
`;

const StyledPage = styled(Flex)`
  justify-content: space-between;
  z-index: 10000;
`;
